import React from 'react'

const PageWrapper = ({
    children
}) => {
  return (
    <div className='h-[85vh] max-h-[100%] p-[50px] w-[100%] overflow-x-auto' >
        {
            children
        }
    </div>
  )
}

export default PageWrapper